export const SEARCHER_DELAY = 800;

export const MAX_SUM_OF_SEARCH_MATCHES = 6;

export const MAX_SUM_OF_PRIORITIES = 3;

export const MAX_SUM_OF_BADGES = 5;

export const ALL_FILTER_OPTION = "all";
